import { AfterViewInit, Component, Input } from '@angular/core';
import * as jsBarcodeLib from 'jsbarcode';

@Component({
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  selector: 'app-bar-code',
  templateUrl: './bar-code.component.html',
  styleUrl: './bar-code.component.scss'
})
export class BarCodeComponent implements AfterViewInit {
  @Input() code!: string;
  @Input() otp?: string;
  @Input() isRedeem = false;
  @Input() couponCode!: string;

  ngAfterViewInit() {
    const height = this.isRedeem || this.couponCode ? 180 : 80;
    const barcodeValue =
      this.isRedeem && this.otp ? `${this.code}${this.otp}` : this.code;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    (jsBarcodeLib.default || jsBarcodeLib)('#barcode', barcodeValue, {
      format: 'CODE128',
      displayValue: false,
      lineColor: '#000',
      width: 3,
      height
    });
  }

  get formattedCode(): string {
    return (this.code ?? '').replace(/(.{5})/g, '$1 ').trim();
  }

  get formattedOtp(): string {
    if (!this.otp) return '';
    return this.otp.length === 6
      ? `${this.otp.slice(0, 3)} ${this.otp.slice(3)}`
      : this.otp.replace(/(.{5})/g, '$1 ').trim();
  }
}
